<div class="w3-large" style="float: right;">
    <a (click)="close()">
        <mat-icon>close</mat-icon>
    </a>
</div>


<div *ngIf="data.type == 1" class="accent h-12" fxLayoutAlign="start center">
    <span class="p-2 h3 pt-4" mat-dialog-title>

        {{'SHARED_CONN_MODULE.DIALOG.ACCEPT_INVITATION' | translate }}

    </span>
</div>

<div *ngIf="data.type == 1" style="padding:10px">
    <span>{{'SHARED_CONN_MODULE.DIALOG.ACCEPT_INVITATION_TO_MESSAGE' | translate }} ?</span>
</div>
<div *ngIf="data.type == 2" class="accent h-12" fxLayoutAlign="start center">
    <span class="p-2 h3 pt-4" mat-dialog-title>

        {{'SHARED_CONN_MODULE.DIALOG.DISCONNECT_CONNECTION' | translate }}

    </span>
</div>

<div *ngIf="data.type == 2" style="padding:10px">
    <span>{{'SHARED_CONN_MODULE.DIALOG.DISCONNECT_CONNECTION_FROM' | translate }} ?</span>
</div>


<div style="text-align: end;">



    <button mat-raised-button color="primary" (click)="dialogRef.close(false)">
        {{'SHARED_CONN_MODULE.DIALOG.CANCEL_BTN' | translate }}
    </button>
    &nbsp;
    <button *ngIf="data.type == 1" mat-raised-button (click)="rejectConnectionInvitation()">
        {{'SHARED_CONN_MODULE.DIALOG.REJECT_BTN' | translate }}
    </button>
    &nbsp;
    <button *ngIf="data.type == 1"  mat-raised-button (click)="acceptConnectionInvitation()">
        {{'SHARED_CONN_MODULE.DIALOG.ACCEPT_BTN' | translate }}

    </button>
    &nbsp;

    <button *ngIf="data.type == 2" mat-raised-button (click)="disconnection()">
        {{'SHARED_CONN_MODULE.DIALOG.DISCONN_BTN' | translate }}
    </button>


</div>
